import {
  configureStore,
  ThunkAction,
  Action,
  AnyAction,
  combineReducers,
  // Middleware
} from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { useDispatch } from 'react-redux';

import reducer from './reducers';

type LocationState = {
  chooseTemplateModal?: boolean;
};

export const history = createBrowserHistory<LocationState>();

const appReducer = combineReducers(reducer);

export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === 'personefy_logout/fulfilled') {
    return appReducer(undefined, action);
  }
  // return appReducer(curState, action);
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer, // reducer,
  //reducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: { history },
      },
    }),
});

// export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
